import { useFetchViewsByCategory } from '../../standardViews/hooks/useFetchViewsByCategory';
import { useDebouncedValue } from '../../cloneView/hooks/useDebouncedValue';
import { useMemo } from 'react';
const QUERY_OBJECT_DEBOUNCE_TIME_MS = 500;
export const useDebouncedFetchViewsByCategory = ({
  objectTypeId,
  query,
  namespace,
  category,
  count = 6
}) => {
  const viewsSearchQuery = useMemo(() => ({
    objectTypeId,
    query,
    namespace,
    category,
    count
  }), [objectTypeId, namespace, category, query, count]);
  const debouncedViewsSearchQuery = useDebouncedValue(viewsSearchQuery, QUERY_OBJECT_DEBOUNCE_TIME_MS);
  return useFetchViewsByCategory(debouncedViewsSearchQuery);
};